export default {
  name: 'نام شرکت/شخص',
  username: 'شناسه یکتا',
  save: 'ذخیره',
  address: 'آدرس',
  postalCode: 'کد پستی',
  description: 'توضیحات',
  subject: 'زمینه‌ی فعالیت',
  phoneNumber: 'تلفن',
  selectTheLocationOnTheMap:
    'لطفاً مکان مورد نظر خود را در نقشه با دقت انتخاب کنید.',
  removeLocation: 'حذف موقعیت مکانی',
};
